export function getApiKeys() {
    const token = sessionStorage.getItem("key");
    const user = sessionStorage.getItem("user");
    const clienteId = sessionStorage.getItem("client_id");

    return { token, user, clienteId };
}
